export function StatusBadge({ status }) {
  return <span className={`status status-${String(status || 'default').toLowerCase()}`}>{status || 'Unknown'}</span>;
}
